import React from "react";
import { Toast, Modal, Tabs, Badge, ListView } from "antd-mobile";
import Http from "../../utils/http";
import * as Api from "../../utils/api";
import VedioPlayer from "../../components/vedio";
import EvaluteItem from "./List/EvaluteItem";
import Utils from "../../utils/utils";
import Base64 from "crypto-js/enc-base64";
import HmacSha256 from "crypto-js/hmac-sha256";
import CourseItem from "../../components/home/CourseItem";
const GLOBAL_IMAGE_URL = Api.imageGlobalUrl;

let icon_time_image = require("../../assets/images/icon_time.png");

const alert = Modal.alert;
const HttpInstance = new Http();
const utils = new Utils();
export default class CourseVedio extends React.Component {
  constructor(props) {
    super(props);
    const ds = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2, // 用其进行数据变更的比较 必须这么写
    });
    this.state = {
      paddingTop: 0,
      isApp: true,
      isShowIns: true,
      isBindPhone: false,
      isCanBuy: true,
      userInfo: {},
      loginData: {},
      isVipPrivilege: false, //是否vip专享
      isShowCourse: true,
      courseInfo: {
        courseID: "",
        experter: "高培毅",
        experterIns:
          "中国放射科宗师级医生,放射科信息化奠基人，本节课是一节实践性很强的应用科学专业。它致力于培养具备基础医学、临床医学的基本理论和医疗玉芳XXXXXXXXX",
        name: "放射科医生PET-CT初步诊断快速入门及进阶",
      },
      TimerOut: {},
      navList: [
        {
          id: 1001,
          name: "学习资料",
        },
        {
          id: 1002,
          name: "课程选集",
        },
      ],
      catalogueList: [],
      vedioInfo: {
        videoUrl: "",
      },
      progress: 0,
      vedioUrl: "",
      evaluate: {
        evaluateList: [],
      },
      totalTimes: 0,
      totalStar: 0,
      currentTab: 0,
      currentPlay: 0,
      pages: {
        pageIndex: 1,
        pageSize: 10,
      },
      tip: "视频加载中...",
      AppConfig: {
        scheme: "fssl",
        package: "com.fssl.salon",
        action: "android.intent.action.VIEW",
        category: "android.intent.category.BROWSABLE",
        // host: "https://sj.qq.com",
        host: "https://a.app.qq.com",
        FAILBACK_ANDROID:
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.yiban.salon",
        FAILBACK_IOS:
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.yiban.salon",
        // FAILBACK_ANDROID:
        //   "https://sj.qq.com/myapp/detail.htm?apkName=com.yiban.salon",
        // FAILBACK_IOS:
        //   "https://sj.qq.com/myapp/detail.htm?apkName=com.yiban.salon",
      },
      // 用户头像
      userImg: "",
      customKey: "",
      signature: "",
      tabs: [
        { title: "简介" },
        { title: "目录" },
        { title: "评价" },
        { title: "推荐" },
      ],
      // 推荐数据
      recommendCourseData: [],
      dataSource: ds,
      height: 400,
      isLoading: true,
      hasMore: true,
      pageIndex: 1,
      pageSize: 10,
      isIPhone: false,
      playbackRate: 1,
      courseID: "",
      cPageIndex: 1,
      cPageSize: 10,
      cIsLoading: true,
      cHasMore: true,
      // 评论数据
      commoentData: [],
      cDataSource: ds,
      starAvg: 0,
    };
  }
  renderRow = (item, index) => {
    console.log("11", item, index);
    return (
      <div className="course-item" onClick={() => this.courseDetail(item)}>
        <div className="proxy-image">
          <img src={GLOBAL_IMAGE_URL + item.iconUrl} />
          <div className="proxy-text">{item.playCount}人在学</div>
          <div className="proxy-innerbg"></div>
        </div>
        <div className="courseInfo">
          <div className="info">
            <p className="p-title">
              {item.expertName}&nbsp;&nbsp;&nbsp;&nbsp;{item.title}
            </p>
            <p className="p-name">{item.courseName}</p>
          </div>
          <div>
            {
              //  <div className="buyedStatus">免费</div>

              //  <div className="buyedStatus">已购</div>
              <p className="p-price">
                <span className="price-flag">￥</span>
                <span className="price">{item.price}</span>
                <del>
                  <span>原价&nbsp;&nbsp;</span>
                  <span className="price-delfalg">￥</span>
                  <span>{item.oldPrice}</span>
                </del>
              </p>
            }
          </div>
        </div>
      </div>

      // <div>
      //   <div>{item.courseName}</div>
      // </div>
    );
  };
  renderCommentRow = (item, index) => {
    console.log("评论item", item);
    return (
      <div className="inner-evaluate" key={item.id}>
        <div className="evaluate-item">
          <div className="item-user">
            <div className="user-avatar">
              <img src={GLOBAL_IMAGE_URL + item.avatar} />
            </div>

            <div className="user-stars">
              <p className="username">{item.userName}</p>

              <p className="stars">{this.renderStar(item.stars)}</p>
            </div>
          </div>

          <div className="item-content">
            <p>{item.content}</p>
          </div>
        </div>
        <div className="separator-line"></div>
      </div>
    );
  };
  renderStar(number) {
    let arr = [];

    for (let index = 0; index < number; index++) {
      const element = (
        <img key={index} src={require("../../assets/images/icon_star.png")} />
      );

      arr.push(element);
    }

    return arr;
  }
  onCommentEndReached = (event) => {
    console.log("cIsLoading", this.state.cIsLoading);
    console.log("cHasMore", this.state.cHasMore);
    // 加载中或者没有更多数据将不再进行加载
    if (this.state.cIsLoading || !this.state.cHasMore) {
      // alert(1)
      return;
    }
    this.setState(
      {
        cPageIndex: this.state.cPageIndex + 1,
        cIsLoading: true,
      },
      () => {
        this.queryCourseEvalute();
      }
    );
  };
  onEndReached = (event) => {
    // 加载中或者没有更多数据将不再进行加载
    if (this.state.isLoading || !this.state.hasMore) {
      return;
    }
    this.setState(
      {
        pageIndex: this.state.pageIndex + 1,
        isLoading: true,
      },
      () => {
        this.getCourseRecommedData();
      }
    );
  };
  render() {
    const _this = this;
    return (
      <div
        className="vedio-course-container"
        style={{
          paddingTop:
            _this.state.paddingTop <= 240 ? 240 : _this.state.paddingTop,
        }}
      >
        {/* <div className="globalText">该功能正在升级中，敬请期待</div> */}
        <div className="navBar">
          <div onClick={_this.goHome.bind(_this)}>首页</div>
          <div onClick={_this.goPersonalCenter.bind(_this)}>
            <img src={GLOBAL_IMAGE_URL + this.state.userImg} />
          </div>
        </div>
        {_this.state.vedioUrl ? (
          <VedioPlayer
            ref="myVedio"
            isApp={_this.state.isApp}
            vedioPoster={_this.state.courseInfo.iconUrl}
            vedioUrl={_this.state.vedioUrl}
            progress={_this.state.progress}
            history={_this.props.history}
            height={
              _this.state.paddingTop <= 240 ? 240 : _this.state.paddingTop
            }
          ></VedioPlayer>
        ) : (
          <div
            className="vedioContainer"
            style={{
              height:
                _this.state.paddingTop <= 240 ? 240 : _this.state.paddingTop,
            }}
          >
            <div className="noPlayTipDiv">{_this.state.tip}</div>
          </div>
        )}

        <div className="video-course-content">
          <Tabs
            tabs={_this.state.tabs}
            initialPage={0}
            swipeable={false}
            style={{
              top: _this.state.paddingTop <= 240 ? 240 : _this.state.paddingTop,
            }}
            onChange={(tab, index) => _this.tabChange(tab, index)}
          >
            <div
              style={{
                // display: "flex",
                // alignItems: "center",
                // justifyContent: "center",
                // height: "250px",
                backgroundColor: "#fff",
                paddingTop: "44px",
                paddingBottom: "100px",
              }}
            >
              <div className="course-header">
                <div className="header-title">
                  <div className="title">
                    {" "}
                    {_this.state.courseInfo.courseName}{" "}
                  </div>
                  <div
                    className="operation"
                    onClick={_this.insClickHandle.bind(_this)}
                  >
                    简介
                  </div>
                </div>
                <p className="header-tips">
                  {utils.converToNum(_this.state.courseInfo.playCount || 1)}
                  人在学
                </p>
              </div>
              <div
                className={
                  _this.state.isShowIns
                    ? "separator-line"
                    : "separator-line expert-none"
                }
              ></div>
              <div
                className={
                  _this.state.isShowIns
                    ? "expert-container"
                    : "expert-container expert-none"
                }
              >
                <p className="expert">{_this.state.courseInfo.expertName}</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: _this.state.courseInfo.introductionUeditor,
                  }}
                ></p>
              </div>
            </div>
            <div
              style={{
                // display: "flex",
                // alignItems: "center",
                // justifyContent: "center",
                // height: "250px",
                backgroundColor: "#fff",
                paddingTop: "44px",
                paddingBottom: "100px",
              }}
            >
              <div className="separator-block"></div>
              <div className="course-catalogue">
                <div className="catalogue-title">
                  <div className="title">课程目录</div>
                  <div className="time">共计{_this.state.totalTimes}</div>
                </div>
                <div className="catalogue-content">
                  {_this.state.catalogueList.map((item, index) => {
                    return (
                      <div key={index}>
                        <div
                          className={
                            item.canPlay
                              ? "catalogue-item"
                              : "catalogue-item item-noplay"
                          }
                          onClick={_this.troggleVedio.bind(_this, item, index)}
                        >
                          <div className="item-name">
                            <div
                              className={
                                _this.state.currentPlay == index &&
                                item.canPlay == true
                                  ? "active title"
                                  : "title"
                              }
                            >
                              {_this.state.currentPlay == index &&
                              item.canPlay == true ? (
                                <img
                                  src={require("../../assets/images/icon_play.png")}
                                />
                              ) : (
                                index + 1 + "、"
                              )}
                              {item.chapterTitle}
                            </div>
                            {item.isAudition ? (
                              <div className="flag">试听</div>
                            ) : null}
                            {item.isNew ? (
                              <div className="flag flag-new">New</div>
                            ) : null}
                            {item.isShow == 1 ? null : (
                              <div className="flag-noplay">未开播</div>
                            )}
                          </div>
                          <div className="item-time" style={uiIconImageStyle}>
                            {item.playTime}
                          </div>
                        </div>
                        {_this.state.catalogueList.length ==
                        index + 1 ? null : (
                          <div className="separator-line"></div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="separator-block"></div>
            </div>
            {/* 评价 */}
            <div
              style={{
                // display: "flex",
                // alignItems: "center",
                // justifyContent: "center",
                // height: "250px",
                // backgroundColor: "#fff",
                // paddingTop: "44px",
                // paddingBottom: "100px",
                height: _this.state.height + "px",
                backgroundColor: "#fff",
                paddingTop: "44px",
                paddingBottom: "50px",
              }}
            >
              <ListView
                dataSource={_this.state.cDataSource.cloneWithRows(
                  _this.state.commoentData
                )}
                renderRow={(item, index) => _this.renderCommentRow(item, index)}
                style={{
                  height: "100%",
                }}
                renderHeader={() => (
                  <div className="course-catalogue">
                    <div className="catalogue-title">
                      <div className="title">
                        {" "}
                        课程评价&nbsp;&nbsp;
                        {_this.state.starAvg ? _this.state.starAvg + "分" : ""}
                      </div>
                    </div>
                  </div>
                )}
                renderFooter={() => (
                  <div style={{ padding: 30, textAlign: "center" }}>
                    {_this.state.cIsLoading ? "加载中..." : "暂无更多数据"}
                  </div>
                )}
                onEndReached={_this.onCommentEndReached}
                onEndReachedThreshold={50}
              />
            </div>
            {/* </div> */}
            {/* </div> */}
            {/* 目录 */}
            <div
              style={{
                // display: "flex",
                // alignItems: "center",
                // justifyContent: "center",
                height: _this.state.height + "px",
                backgroundColor: "#fff",
                paddingTop: "44px",
                paddingBottom: "50px",
              }}
            >
              {/* <div className="module-course"> */}
              <ListView
                dataSource={_this.state.dataSource.cloneWithRows(
                  _this.state.recommendCourseData
                )}
                renderRow={(item, index) => _this.renderRow(item, index)}
                style={{
                  height: "100%",
                }}
                renderFooter={() => (
                  <div style={{ padding: 30, textAlign: "center" }}>
                    {_this.state.isLoading ? "加载中..." : "暂无更多数据"}
                  </div>
                )}
                onEndReached={_this.onEndReached}
                onEndReachedThreshold={50}
              />
            </div>
          </Tabs>
        </div>

        {!_this.state.courseInfo.enable && !_this.isVipPrivilege ? (
          <div className="courseFixBtnContianer">
            <div className="btn btn-contact money">
              <span>￥</span>
              <span>{_this.state.courseInfo.defaultPrice}</span>
            </div>
            <button className="btn btn-buy" onClick={_this.nowBuy.bind(this)}>
              立即购买
            </button>
          </div>
        ) : (
          <div className="homeFixBtnContainer">
            <button
              className="btn btn-contact"
              onClick={_this.contactUs.bind(this)}
            >
              联系客服
            </button>
            <button
              className="btn btn-download"
              onClick={_this.downLoad.bind(_this)}
            >
              下载放射沙龙App
            </button>
          </div>
        )}
      </div>
    );
  }
  // 修改url参数
  replaceParamVal(paramName, replaceWith) {
    var oUrl = this.location.href.toString();
    var re = eval("/(" + paramName + "=)([^&]*)/gi");
    var nUrl = oUrl.replace(re, paramName + "=" + replaceWith);
    return nUrl;
  }
  courseDetail(item) {
    console.log("item", item);
    console.log("111", window.location.href, item.courseID);
    let url = window.location.href.toString();
    let re = eval("/(courseID=)([^&]*)/gi");
    let handleUrl = url.replace(re, "courseID=" + item.courseID);
    console.log("handleUrl", handleUrl);
    window.location.href = handleUrl;
    window.location.reload();

    // this.props.history.push({
    //   pathname: "/play",
    //   search: "?courseID=" + item.courseID,
    // });
  }

  componentWillMount() {
    Toast.loading("加载中...", 0, true);
    document.title = "课程详情";
    window.scrollTo(0, 0);

    // pushHistory();
    // window.addEventListener(
    //   'popstate',
    //   () => this.addPlayRecore(),

    //   false
    // );
    // function pushHistory() {
    //   var state = {
    //     title: 'title',
    //     url: '#',
    //   };

    //   window.history.pushState(state, 'title', '#');
    // }
  }

  componentDidMount() {
    console.log("进入页面", document.documentElement.clientHeight);
    let height =
      document.documentElement.clientHeight - this.state.paddingTop - 44;
    this.setState({
      height: height,
    });
    document.getElementsByClassName(
      "am-tabs-default-bar-underline"
    )[0].className = "am-tabs-default-bar-underline tabTriangleOne";
    // localStorage.removeItem('customKey')
    // localStorage.removeItem('isApp')
    const _this = this;

    const date = new Date();

    this.start = date.getTime();
    // 判断课程链接地址是否是定制化链接
    // const urlSearch= this.props.location.search
    const urlSearch = this.props.location.search.replace(/\+/g, "%2B");
    const cId = HttpInstance.getSearchByName(urlSearch, "courseID");
    const customKey = HttpInstance.getSearchByName(urlSearch, "customKey");
    const signature = HttpInstance.getSearchByName(urlSearch, "signature");
    console.log(cId);
    console.log(customKey);
    console.log(signature);
    document.addEventListener("contextmenu", this._handleContextMenu);
    if (customKey && signature) {
      // 是定制化链接
      const newSignature = _this.createSignature(cId, customKey);
      if (signature != newSignature) {
        // console.log('不相同')
        Toast.hide();
        Toast.info("网络异常");
        return;
      } else {
        console.log("相同");
        // localStorage.setItem('customKey',customKey)
      }
    }
    // 进入页面判断是否有授权信息
    // 获取登录信息

    const accessToken = HttpInstance.getSearchByName(
      this.props.location.search,

      "accessToken"
    );

    const openID = HttpInstance.getSearchByName(
      this.props.location.search,

      "openID"
    );

    const unionid = HttpInstance.getSearchByName(
      this.props.location.search,

      "unionid"
    );

    const userID = HttpInstance.getSearchByName(
      this.props.location.search,

      "userID"
    );

    let loginData;

    let loginTime;

    if (accessToken) {
      let loginParams = {
        accessToken: accessToken,

        openID: openID,

        unionid: unionid,

        userID: userID,
      };

      loginTime = new Date().getTime();

      loginParams = JSON.stringify(loginParams);

      localStorage.setItem("loginData", loginParams);

      loginData = loginParams;
    } else {
      loginTime = localStorage.getItem("loginTime");

      if (!loginTime) {
        localStorage.removeItem("loginData");

        localStorage.removeItem("code");
      }

      loginData = localStorage.getItem("loginData");
    }

    // 获取当前时间

    let nowTime = new Date().getTime();

    let resultTime = parseInt(nowTime - loginTime);

    console.log("时间", resultTime);

    console.log("loginData", loginData);

    if (!loginData || resultTime > 7200000) {
      console.log("登录授权");
      Toast.hide();

      // 未登录授权----让用户去登陆授权

      let isApp = HttpInstance.getSearchByName(
        this.props.location.search,

        "isApp"
      );

      let courseId = HttpInstance.getSearchByName(
        this.props.location.search,

        "courseID"
      );

      isApp = isApp ? true : false;
      // localStorage.setItem("isApp", isApp);

      _this.setState(
        {
          courseID: courseId,
          isApp: isApp,
          customKey: customKey,
          signature: signature,
        },

        () => {
          _this.toLogin();
        }
      );
    } else {
      console.log("登录信息存在");
      loginData = JSON.parse(loginData);
      // console.log('处理登录信息',loginData)
      // console.log('登录信息存在customKey',customKey)
      // 删除localStorage中的定制化信息
      if (!customKey && loginData.customKey) {
        delete loginData.customKey;
        delete loginData.signature;
        loginData = JSON.stringify(loginData);
        localStorage.setItem("loginData", loginData);
      }

      // 添加localStorage中的定制化信息--替换localStorage中的定制化信息
      if (
        (customKey && !loginData.customKey) ||
        (customKey && loginData.customKey)
      ) {
        loginData.customKey = customKey;
        loginData.signature = signature;
        loginData = JSON.stringify(loginData);
        localStorage.setItem("loginData", loginData);
      }
      /**

       * 判断是否App内打开*/

      let userInfo = localStorage.getItem("userInfo");

      let isApp = HttpInstance.getSearchByName(
        this.props.location.search,

        "isApp"
      );

      let courseId = HttpInstance.getSearchByName(
        this.props.location.search,

        "courseID"
      );

      let chapter = HttpInstance.getSearchByName(
        this.props.location.search,

        "chapter"
      );

      let progress = HttpInstance.getSearchByName(
        this.props.location.search,

        "progress"
      );

      isApp = isApp ? true : false;
      // localStorage.setItem("isApp", isApp);

      _this.setState(
        {
          courseID: courseId,

          progress: progress,

          isApp: isApp,

          paddingTop: 240,
          customKey: customKey,
          signature: signature,
        },

        () => {
          _this.getPageInfo();
        }
      );

      if (userInfo && userInfo.courseId) {
        _this.setState({
          userInfo: userInfo,
        });
      }

      if (chapter) {
        _this.setState({
          currentPlay: chapter - 1,

          chapter: chapter,
        });
      }

      // console.log('是不是app',isApp)

      // console.log('课程信息',this.state.courseInfo);

      // if(!isApp){

      //     utils.wxShareConfig(_this,isApp,courseId,)

      // }
    }
  }
  _handleContextMenu = (event) => {
    event.preventDefault();
    return false;
  };
  componentWillUnmount() {
    // console.log('页面离开')
    document.removeEventListener("contextmenu", this._handleContextMenu);
    if (this.state.vedioInfo) {
      this.addPlayRecore(this.state.vedioInfo);
    }
  }

  // 获取课程的推荐信息
  getCourseRecommedData() {
    let params = {};
    params.courseID = this.state.courseID;
    params.pageIndex = this.state.pageIndex;
    params.pageSize = this.state.pageSize;

    let response = HttpInstance.post(Api.QUERY_COURSERECOMMEND_API, params);
    response.then((res) => {
      console.log("推荐数据", res);
      let data = res.data;
      if (data.result) {
        // this.setState({
        //   recommendCourseData: data.data,
        // });
        let dataList = data.data;
        let len = dataList.length;
        if (len <= 0) {
          this.setState({
            isLoading: false,
            hasMore: false,
          });
          return false;
        }

        // 此时还有数据
        let recommendCourseArr =
          this.state.recommendCourseData.concat(dataList);
        this.setState({
          pageIndex: this.state.pageIndex,
          dataSource: this.state.dataSource.cloneWithRows(recommendCourseArr),
          isLoading: false,
          recommendCourseData: recommendCourseArr,
        });
      }
    });
  }
  // tab栏切换
  tabChange(tab, index) {
    console.log("tab栏切换", tab, index);
    switch (index) {
      case 0:
        document.getElementsByClassName(
          "am-tabs-default-bar-underline"
        )[0].className = "am-tabs-default-bar-underline tabTriangleOne";
        break;
      case 1:
        document.getElementsByClassName(
          "am-tabs-default-bar-underline"
        )[0].className = "am-tabs-default-bar-underline tabTriangleTwo";
        break;
      case 2:
        document.getElementsByClassName(
          "am-tabs-default-bar-underline"
        )[0].className = "am-tabs-default-bar-underline tabTriangleThree";
        break;
      case 3:
        document.getElementsByClassName(
          "am-tabs-default-bar-underline"
        )[0].className = "am-tabs-default-bar-underline tabTriangleFour";
        break;
    }
  }

  //生成签名
  createSignature(courseID, customKey) {
    const _this = this;
    let keymap = {
      courseID: courseID,
      customKey: customKey,
    };
    let arrayKey = Object.keys(keymap);
    arrayKey = _this.lineupString(arrayKey); //升序排列
    let signUrl = "";
    for (let i = 0; i < arrayKey.length; i++) {
      if (i == 0) {
        signUrl = signUrl + arrayKey[i] + "=" + keymap[arrayKey[i]];
      } else {
        signUrl = signUrl + "&" + arrayKey[i] + "=" + keymap[arrayKey[i]];
      }
    }
    signUrl = HmacSha256(signUrl, "qx8VHRyMkOkHkSFH"); //HmacSHA256加密
    signUrl = Base64.stringify(signUrl); //base64编码
    return signUrl;
  }
  lineupString(stringArray) {
    if (stringArray.length > 0) {
      stringArray.sort(function (a, b) {
        return a.localeCompare(b);
      });
      return stringArray;
    } else {
      return;
    }
  }

  /**
   * 上传播放记录；
   */
  addPlayRecore(videoInfo) {
    console.log("播放记录");
    try {
      if (!this.refs.myVedio.player || !this.state.vedioInfo) return;
      const date = new Date();
      this.endTime = date.getTime();
      const { player } = this.refs.myVedio.player.getState();

      let progress = Math.floor((player.currentTime * 100) / player.duration);
      console.log("判断", isNaN(progress));
      if (isNaN(progress)) {
        console.log("是NaN");
        return false;
      }
      const params = {
        courseId: this.state.courseID,
        videoId: videoInfo.id,
        // 章节id
        chapterId: videoInfo.chapterId,
        playProgress: progress,
        videoTime: videoInfo.playTimeComputed,
        studyTime: 0,
      };
      let response = HttpInstance.post(Api.ADD_PLAYRECORD_API, params);
      response.then((data) => {
        console.log("上传播放记录", data);
      });
      // this.props.history.go(-1);
    } catch (error) {
      // this.props.history.go(-1);
      console.log("上传播放记录失败");
    }
  }
  /**
   * 顶部导航首页按钮点击事件
   */
  goHome() {
    console.log("首页");
    window.location.href = `${Api.AUTH_WAYPAY_URL}/fssl-gzh/#/index`;
  }
  /**
   * 顶部导航头像按钮点击事件
   */
  goPersonalCenter() {
    console.log("个人中心");
    window.location.href = `${Api.AUTH_WAYPAY_URL}/fssl-gzh/#/personalCenter`;
  }
  toLogin() {
    const _this = this;
    let linkUrl = window.location.href;
    let code = HttpInstance.UrlSearchCode(linkUrl);
    // 判断是否存在code
    if (code && code != "") {
      //根据code去获取openId
      console.log("根据code获取opendId");
      _this.getOpenId(code);
    } else {
      // _this.getPageInfo();
      // 获取code
      console.log("获取code");
      _this.getCode();
    }
  }
  getOpenId(code) {
    const _this = this;
    let liveCode = localStorage.getItem("code");
    if (liveCode && liveCode !== "") {
      if (liveCode == code) {
        _this.getPageInfo();
      } else {
        localStorage.setItem("code", code);
        _this.loginByCode(code);
      }
    } else {
      localStorage.setItem("code", code);
      _this.loginByCode(code);
    }
  }
  getCode() {
    console.log("getCode方法");
    let courseId = HttpInstance.getSearchByName(
      this.props.location.search,
      "courseID"
    );
    const urlSearch = this.props.location.search.replace(/\+/g, "%2B");
    const customKey = HttpInstance.getSearchByName(urlSearch, "customKey");
    const signature = HttpInstance.getSearchByName(urlSearch, "signature");
    const isApp = HttpInstance.getSearchByName(urlSearch, "isApp");
    console.log("customKey", customKey);
    console.log("signature", signature);
    console.log("isApp", isApp);
    var locationUrl = encodeURIComponent(
      Api.AUTH_GLOBAL_COURSE_URL + "?courseID=" + courseId
    );
    // if (customKey) {
    //   locationUrl += "&customKey=" + customKey;
    // }
    // if (signature) {
    //   locationUrl += "&signature=" + signature;
    // }
    if (customKey && signature) {
      let customData = {
        customKey: customKey,
        signature: signature,
        isApp: isApp ? true : false,
      };
      customData = JSON.stringify(customData);
      localStorage.setItem("customData", customData);
    }

    console.log("locationUrl", locationUrl);
    window.location.href =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdcac93666607fff5&redirect_uri=" +
      locationUrl +
      "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
  }
  loginByCode(code) {
    const _this = this;
    let params = {};
    params.wxCode = code;
    let response = HttpInstance.login(Api.QUERY_ACCESSTOKEN_API, params);
    let customData = JSON.parse(localStorage.getItem("customData"));
    response.then((data) => {
      let responseData = data.data;
      if (responseData.result) {
        let loginParams = {};
        loginParams.accessToken = responseData.data["accessToken"];
        loginParams.openID = responseData.data["openID"];
        loginParams.unionid = responseData.data["unionid"];
        loginParams.userID = responseData.data["userID"];
        if (customData) {
          loginParams.isApp = customData.isApp;
          loginParams.customKey = customData.customKey;
          loginParams.signature = customData.signature;
        } else {
          loginParams.isApp = _this.state.isApp;
          loginParams.customKey = _this.state.customKey;
          loginParams.signature = _this.state.signature;
        }
        localStorage.removeItem("customData");
        loginParams = JSON.stringify(loginParams);
        localStorage.setItem("loginData", loginParams);
        // localStorage.setItem("isApp", _this.state.isApp);
        let loginTime = new Date().getTime();
        localStorage.setItem("loginTime", loginTime);
        _this.getPageInfo();
      }
    });
  }

  /**
   * 获取页面信息
   * */
  getPageInfo() {
    console.log("获取页面信息");
    let _this = this;
    // if (!_this.state.isApp) {
    //   // 非app进入
    //   _this.queryBindPhone();
    // } else {
    //   // app进入
    //   // 获取用户头像
    //   _this.queryUserInfo();
    //   // 获取课程信息
    //   _this.queryCourseInfo();
    //   // 获取课程评论
    //   _this.queryCourseEvalute();
    // }
    // 获取用户头像
    _this.queryUserInfo();
    // 获取课程信息
    _this.queryCourseInfo();
    // 获取课程评论
    _this.queryCourseEvalute();
    // 获取课程推荐数据
    _this.getCourseRecommedData();
  }
  /**
   * 切换栏目
   * @param index
   *  */
  selectTab(index) {
    const _this = this;
    _this.setState({
      currentTab: index,
    });
  }
  /**
   * 课程简介
   *  */
  insClickHandle() {
    const _this = this;
    _this.setState({
      isShowIns: !_this.state.isShowIns,
    });
  }
  /**
   * 立即购买
   *  */
  nowBuy() {
    Toast.loading("加载中...", 0, true);
    const _this = this;
    let isApp = HttpInstance.getSearchByName(
      this.props.location.search,
      "isApp"
    );
    // let isBind = _this.state.isBindPhone;
    let userInfo = _this.state.userInfo;
    userInfo.coupon = {};
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    // 查询是否绑定手机号
    // if (isApp) {
    //   _this.props.history.push({
    //     pathname: "/order",
    //     search: "?courseID=" + _this.state.courseID,
    //   });
    // } else {
    // 不是App的进行判断是否绑定手机号
    this.queryBindPhone();
    // }

    // if (isBind) {
    //   _this.props.history.push({
    //     pathname: "/order",
    //     search: "?courseID=" + _this.state.courseID,
    //   });
    // } else {
    //   _this.props.history.push({ pathname: "/bind" });
    // }
  }
  /**
   * 获取用户信息
   */
  queryUserInfo() {
    let response = HttpInstance.get(Api.QUERY_USERINFO_API, {});
    response.then((res) => {
      let data = res.data;
      console.log("用户信息", data);
      if (data.result) {
        this.setState({
          userImg: data.data.ImageUrl,
        });
      }
    });
  }
  /**
   * 获取课程信息
   *  */
  queryCourseInfo() {
    const _this = this;
    let params = {};
    params.courseID = _this.state.courseID;
    let response = HttpInstance.post(Api.QUERY_COURSE_API, params);
    response.then((data) => {
      let responseData = data.data;
      if (responseData.result) {
        let courseInfo = responseData.data;
        let isBuy = Number(courseInfo.isBuy);
        let isFree = Number(courseInfo.isFree);
        this.isVipPrivilege = !!courseInfo.isVipPrivilege;

        if (_this.state.isApp) {
          if (isBuy === 0 && isFree === 0) {
            _this.setState({
              isShowCourse: false,
              // isCanBuy: false,
              isCanBuy: true,
            });
          } else {
            _this.setState({
              isShowCourse: true,
              isCanBuy: false,
            });
          }
        } else {
          utils.wxShareConfig(
            _this,
            _this.state.isApp,
            _this.state.courseID,
            courseInfo.courseName,
            courseInfo.introduction,
            courseInfo.iconUrl
          );
          if (isBuy === 0 && isFree === 0) {
            // 为购买并且不免费
            _this.setState({
              isShowCourse: false,
              isCanBuy: true,
            });
          } else {
            _this.setState({
              isShowCourse: true,
              isCanBuy: false,
            });
          }
        }
        let setCourseInfo = JSON.stringify(courseInfo);
        localStorage.setItem("courseInfo", setCourseInfo);
        _this.setState(
          {
            courseInfo: courseInfo,
          },
          () => {
            _this.queryCourseVedio();
            console.log("是不是app", this.state.isApp);
            console.log("课程信息", this.state.courseInfo);
            // if (!this.state.isApp) {
            //     utils.wxShareConfig(_this, _this.state.isApp, _this.state.courseID, courseInfo.courseName, courseInfo.introduction, courseInfo.iconUrl)
            // }
            // 关闭loading
            Toast.hide();
          }
        );
      }
    });
  }
  /**
   * 获取是否绑定手机号
   * */
  queryBindPhone() {
    const _this = this;
    let loginData = localStorage.getItem("loginData");
    let params = {};

    if (loginData) {
      loginData = JSON.parse(loginData);
      params.openId = loginData.openID;
      params.unionid = loginData.unionid;
      let response = HttpInstance.postJSON(Api.QUERY_PHONEBIND_API, params);
      response.then((data) => {
        let responseData = data.data;
        console.log("获取是否绑定手机号", responseData);
        if (responseData.result) {
          // 绑定了手机号
          Toast.hide();
          _this.props.history.push({
            pathname: "/order",
            search: "?courseID=" + _this.state.courseID,
          });
        } else {
          // 未绑定手机号
          Toast.hide();
          _this.props.history.push({ pathname: "/bind" });
        }
      });
    }
    // _this.setState(
    //   {
    //     isBindPhone: true,
    //   },
    //   () => {
    //     // 获取用户头像
    //     _this.queryUserInfo();
    //     // 获取课程信息
    //     _this.queryCourseInfo();
    //     // 获取课程评论
    //     _this.queryCourseEvalute();
    //   }
    // );
  }
  /**
   * 切换视频
   * */
  troggleVedio(item, index) {
    console.log("切换播放视频", item);
    const _this = this;
    // 解决购买之后未开播能播放的问题
    if (item.isShow == 0) {
      return;
    }
    console.log("播放记录上传方法", _this.state.vedioInfo);
    // 切换视频的时候上传播放记录
    if (_this.state.vedioInfo) {
      _this.addPlayRecore(_this.state.vedioInfo);
    }
    if (
      _this.state.isShowCourse ||
      item.isAudition == true ||
      (_this.state.isShowCourse && item.isShow == 1)
    ) {
      let params = {};
      _this.setState(
        {
          currentPlay: index,
          vedioInfo: _this.state.catalogueList[index],
        },
        () => {
          console.log("哈哈哈", _this.state.vedioInfo);
          _this.queryVideoSign();
        }
      );
    }
  }
  /**
   * 切换视频播放*/
  queryCourseVedio() {
    const _this = this;
    let params = {};
    params.courseID = _this.state.courseID;
    let response = HttpInstance.post(Api.QUERY_COURSEVEDIO_API, params);
    response.then((data) => {
      let responseData = data.data;
      if (responseData.result) {
        let catalogueList = responseData.data;
        //计算总时间
        let totalTime = 0;
        let videoIndex = 0;
        if (catalogueList.length > 0) {
          catalogueList = catalogueList.map((item, index) => {
            totalTime += item.playTime;
            console.log(_this.state.isShowCourse);
            if (_this.state.isShowCourse || item.isAudition === true) {
              if (item.isShow == 1) {
                item.canPlay = true;
                if (videoIndex === 0) videoIndex = index;
              } else {
                item.canPlay = false;
              }
            } else {
              item.canPlay = false;
            }
            item.playTimeComputed = item.playTime;
            item.playTime = HttpInstance.formatSeconds(item.playTime);
            return item;
          });
        }
        console.log("切换视频");
        //如果有播放章节，先获取播放章节
        if (_this.state.chapter && _this.state.chapter != "null") {
          _this.setState(
            {
              vedioInfo: catalogueList[_this.state.chapter - 1],
            },
            () => {
              _this.queryVideoSign(true);
            }
          );
        } else {
          // isAudition  是否是试听
          if (
            (_this.state.isShowCourse && catalogueList[0].isShow == 1) ||
            (catalogueList[0].isAudition && catalogueList[0].isAudition == true)
          ) {
            _this.setState(
              {
                vedioInfo: catalogueList[0],
              },
              () => {
                _this.queryVideoSign();
              }
            );
          } else {
            // 不是试听
            if (videoIndex !== 0) {
              _this.setState(
                {
                  vedioInfo: catalogueList[videoIndex],
                  currentPlay: videoIndex,
                },
                () => {
                  _this.queryVideoSign();
                }
              );
            } else {
              this.setState({ tip: "没有可播放的视频" });
            }
          }
        }
        totalTime = HttpInstance.formatSeconds(totalTime);
        _this.setState({
          catalogueList: responseData.data,
          totalTimes: totalTime,
        });
      }
    });
  }

  //获取视频签名
  queryVideoSign(flag) {
    console.log("获取视频签名");
    const _this = this;
    let params = {};
    let response = HttpInstance.post(Api.QUERY_VEDIO_SIGN, params);
    response.then((data) => {
      let sign = data.data;
      if (_this.state.vedioInfo && _this.state.vedioInfo.videoUrl != "") {
        let vedioUrl = _this.state.vedioInfo.videoUrl + "?sign=" + sign;
        _this.setState(
          {
            vedioUrl: vedioUrl,
          },
          () => {
            // 设置默认的倍速
            console.log("设置默认的倍速", _this.state.playbackRate);

            _this.refs.myVedio.player.playbackRate = _this.state.playbackRate;
            // start-----ios没出现播放按钮
            var Navigator = navigator.userAgent;
            var ifiPad = Navigator.match(/(iPad).*OS\s([\d_]+)/) ? true : false;
            var ifiPhone =
              !ifiPad && Navigator.match(/(iPhone\sOS)\s([\d_]+)/)
                ? true
                : false;
            var ifSafari = (ifiPhone || ifiPad) && Navigator.match(/Safari/);
            var version = 0;
            ifSafari && (version = Navigator.match(/Version\/([\d\.]+)/));
            version = parseFloat(version[1], 10);
            if (
              _this.refs.myVedio.player.getState().player.paused &&
              ifiPhone
            ) {
              _this.setState({
                isIPhone: ifiPhone,
              });
              // 暂停
              document
                .getElementsByClassName("video-react-big-play-button")[0]
                .classList.add("show");
            }
            // end-----ios没出现播放按钮
            setTimeout(() => {
              _this.refs.myVedio.player.video.load();
              if (
                _this.refs.myVedio.player.playbackRate !==
                _this.state.playbackRate
              ) {
                _this.refs.myVedio.player.playbackRate =
                  _this.state.playbackRate;
              }

              _this.refs.myVedio.player.subscribeToStateChange(
                this.handleStateChange.bind(this)
              );
              this.setState({
                // paddingTop:
                //   this.refs.myVedio.player.manager.rootElement.clientHeight +
                //   44 +
                //   20,
                // paddingTop:
                //   this.refs.myVedio.player.manager.rootElement.clientHeight +
                //   44,
              });

              if (flag) {
                let computedProgress =
                  _this.state.vedioInfo.playTimeComputed *
                  (_this.state.progress / 100);
                _this.refs.myVedio.player.video.seek(computedProgress);
              }
            }, 500);
          }
        );
      }
    });
  }
  handleStateChange(state, prevState) {
    // copy player state to this component's state
    // this.setState({
    //   player: state,
    // });
    if (this.state.isIPhone && !state.paused) {
      document
        .getElementsByClassName("video-react-big-play-button")[0]
        .classList.remove("show");
    }
    // console.log("====改变了", state, prevState, this.state.playbackRate);
    // 判断当前播放和存储的播放倍速1 1.5
    // if (state.playbackRate !== this.state.playbackRate) {
    //   console.log("修改倍速");
    //   this.refs.myVedio.player.playbackRate = this.state.playbackRate;
    // } else {
    // 更换倍速时
    if (state.playbackRate !== prevState.playbackRate) {
      console.log("更换倍速了");
      this.setState({
        playbackRate: state.playbackRate,
      });
      // this.setState({
      //   playbackRate: state.playbackRate,
      //   paddingTop:
      //     this.refs.myVedio.player.manager.rootElement.clientHeight + 44 + 20,
      // });
    }
    // }
  }
  /**
   * 请求课程评论数据
   *  */
  queryCourseEvalute() {
    const _this = this;
    /**
     * */
    let params = {};
    params.courseID = _this.state.courseID;
    params.pageIndex = _this.state.cPageIndex;
    params.pageSize = _this.state.cPageSize;
    let response = HttpInstance.post(Api.QUERY_COURSEEVALUTE_API, params);
    response.then((data) => {
      console.log("评论数据", data);
      let responseData = data.data;
      if (responseData.result) {
        let dataList = responseData.data.evaluateList;
        console.log("itemList", dataList);
        let len = dataList.length;
        console.log("len", len);
        // let courseInfo = responseData.data;
        if (responseData.data.starAvg && responseData.data.starAvg != 0) {
          responseData.data.starAvg = responseData.data.starAvg.toFixed(2);
        }
        this.setState({
          starAvg: responseData.data.starAvg,
        });
        if (len <= 0) {
          _this.setState({
            cIsLoading: false,
            cHasMore: false,
          });
          return false;
        }
        // _this.setState({
        //   evaluate: courseInfo,
        // });
        // 此时还有数据
        let commentArr = this.state.commoentData.concat(dataList);
        this.setState({
          cPageIndex: this.state.cPageIndex,
          cDataSource: this.state.cDataSource.cloneWithRows(commentArr),
          cIsLoading: false,
          commoentData: commentArr,
        });
      }
    });
  }
  /**
   * 联系我们 */
  contactUs() {
    alert("拨打客服电话", "0755—22287302 转 8050", [
      {
        text: "取消",
        onPress: () => {},
      },
      {
        text: "继续呼叫",
        onPress: () => {
          window.location.href = "tel:0755—22287302";
        },
      },
    ]);
  }
  getAndroidSchema() {
    const _this = this;
    var Navigator = navigator.userAgent;
    var ifChrome =
      Navigator.match(/Chrome/i) != null &&
      Navigator.match(/Version\/\d+\.\d+(\.\d+)?\sChrome\//i) == null
        ? true
        : false;
    var AppConfig = _this.state.AppConfig;
    var schemaStr = "www.xxx.com/open?a=test";
    if (ifChrome) {
      schemaStr =
        "intent://" +
        schemaStr +
        "#Intent;" +
        "scheme=" +
        AppConfig.scheme +
        ";" +
        "package=" +
        AppConfig.package +
        ";" +
        "category=" +
        AppConfig.category +
        ";" +
        "S.browser_fallback_url=" +
        encodeURIComponent(AppConfig.FAILBACK_ANDROID) +
        ";" +
        "end";
    } else {
      schemaStr = "xxx://www.xxx.com/open";
    }
    return schemaStr;
  }
  downLoad() {
    const _this = this;
    var AppConfig = _this.state.AppConfig;
    // 判断浏览器
    var Navigator = navigator.userAgent;
    var ifChrome =
      Navigator.match(/Chrome/i) != null &&
      Navigator.match(/Version\/\d+\.\d+(\.\d+)?\sChrome\//i) == null
        ? true
        : false;
    var ifAndroid = Navigator.match(/(Android);?[\s\/]+([\d.]+)?/)
      ? true
      : false;
    var ifiPad = Navigator.match(/(iPad).*OS\s([\d_]+)/) ? true : false;
    var ifiPhone =
      !ifiPad && Navigator.match(/(iPhone\sOS)\s([\d_]+)/) ? true : false;
    var ifSafari = (ifiPhone || ifiPad) && Navigator.match(/Safari/);
    var version = 0;
    ifSafari && (version = Navigator.match(/Version\/([\d\.]+)/));
    // safari浏览器版本
    version = parseFloat(version[1], 10);
    // 是否从微信打开
    var ifWeixin = navigator.userAgent.indexOf("MicroMessenger") >= 0; // weixin
    // 由安卓APP提供
    // android打开app 地址
    if (ifAndroid) {
      var s = _this.getAndroidSchema();
      console.log(s);
      if (ifChrome) {
        // chrome会自动识别S.browser_fallback_url如果没有安装则打开下载链接地址
        window.location.href = s;
      } else if (ifWeixin) {
        // 微信无法打开APP，跳转到下载页面
        window.location.href = AppConfig.FAILBACK_ANDROID;
      } else {
        // 其他浏览器3秒内没打开则跳转到下载链接
        window.location.href = s;
        var start = Date.now();
        // 如果页面在后台运行返回，如果超过3秒没有打开APP，则没有安装，跳转到应用市场
        loadTimer = setTimeout(function () {
          if (document.hidden || document.webkitHidden) {
            return;
          }
          if (Date.now() - start <= 3000 + 200) {
            window.location.href = AppConfig.FAILBACK_ANDROID;
          } else {
          }
        }, 3000);
      }
    }

    if (ifiPhone) {
      var openUrl = "fssl://";
      // var universalUrl =
      //   "https://sj.qq.com/myapp/detail.htm?apkName=com.yiban.salon";
      var universalUrl =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.yiban.salon";
      if (ifWeixin) {
        // 微信
        window.location.href = universalUrl;
        return;
      }
      if (ifSafari && version >= 9) {
        // 判断IOS版本 如果大于9
        setTimeout(function () {
          // 必须要使用settimeout
          var ar = document.createElement("a");
          ar.setAttribute("href", openUrl);
          ar.style.display = "none";
          document.body.appendChild(ar);
          var av = document.createEvent("HTMLEvents");
          av.initEvent("click", !1, !1);
          ar.dispatchEvent(av);
        }, 0);
      } else {
        window.location.href = openUrl;
      }
      // 如果页面在后台运行返回，如果超过3秒没有打开APP，则没有安装，跳转到IOS应用市场
      var loadTimer = setTimeout(function () {
        if (document.hidden || document.webkitHidden) {
          return;
        }
        if (Date.now() - start > 3000 + 200) {
        } else {
          window.location.href = AppConfig.FAILBACK_IOS;
        }
      }, 3000);
    }

    // 当页面在后台运行时清空定时器防止页面跳转到下载页
    var visibilitychange = function () {
      var tag = document.hidden || document.webkitHidden;
      tag && clearTimeout(loadTimer);
    };
    document.addEventListener("visibilitychange", visibilitychange, false);
    document.addEventListener(
      "webkitvisibilitychange",
      visibilitychange,
      false
    );
    window.addEventListener(
      "pagehide",
      function () {
        clearTimeout(loadTimer);
      },
      false
    );
  }
}
let uiIconImageStyle = {
  backgroundImage: `url(${icon_time_image})`,
};
